
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-and-insights/thank-you-for-downloading-our-salary-survey",
      function () {
        return require("private-next-pages/news-and-insights/thank-you-for-downloading-our-salary-survey/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-and-insights/thank-you-for-downloading-our-salary-survey"])
      });
    }
  